import React, { useState, useEffect } from 'react';
import './WalkingAnimation.css';
import walkImage from '../../assets/walk.gif'; // Import the image

const WalkingAnimation = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Set a timeout to hide the animation after one cycle (6 seconds)
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 5000); // Match this with the animation duration in CSS

    return () => clearTimeout(timer);
  }, []); // Empty dependency array means this runs once on mount

  if (!isVisible) return null;

  return (
    <div className="walking-animation-container">
      <img 
        src={walkImage}
        alt="Walking Animation"
        className="walking-gif"
      />
    </div>
  );
};

export default WalkingAnimation; 